import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import rootSaga from './rootSaga';
import { rootReducer } from './rootReducer';
import { routerMiddleware, createReduxHistory } from './historyContext';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => import.meta.env.NODE_ENV === 'development' ?
    getDefaultMiddleware().concat(sagaMiddleware).concat(routerMiddleware).concat(createLogger()) :
    getDefaultMiddleware().concat(sagaMiddleware).concat(routerMiddleware)
});

export type RootState = ReturnType<typeof store.getState>;

sagaMiddleware.run(rootSaga);

const history = createReduxHistory(store);

history.listen(() => {
  window.scroll(0, 0);
});

export { store, history };
